module.exports = __webpack_public_path__ + "static/surogat-bw-8e19bb2b6a47cc4442520ac3cd717ccc.jpg";